import React from "react";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { statesAbbreviationList } from "../../../utils/constants/stateAbreviations.ts";

export default function DetailsCard(props) {
  const { loanDetails } = props;
  const getStateAbbreviation = (stateName) => {
    return (
      statesAbbreviationList.find((state) => state.label === stateName)
        ?.value || ""
    );
  };
  if (!loanDetails?.city && !loanDetails?.instituteName && !loanDetails?.workType) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "5px",
        gap: "10px",
      }}
    >
      {loanDetails?.city && (
      <div
        style={{
          backgroundColor: "#F9FAFB",
          color: "#62748e",
          fontFamily: "Outfit",
          padding: "5px 8px 5px 8px",
          height: "30px",
          border: "1px solid #e2e8f0",
          borderRadius: "20px",
          lineHeight: 1,
          width: "fit-content",
        }}
      >
        <LocationOnOutlinedIcon sx={{ color: "#1976d2", fontSize: "14px" }} />
        <span
          style={{
            fontWeight: "800",
            color: "#314158",
            fontSize: "14px",
            lineHeight: 1,
            marginLeft: "8px",
          }}
        >
          {`${loanDetails.city} | `}
          <span style={{ color: "#62748e" }}>
            {getStateAbbreviation(loanDetails.state)}
          </span>
        </span>
      </div>
      )}
      {loanDetails?.instituteName && (
      <div
        style={{
          backgroundColor: "#F9FAFB",
          color: "#62748e",
          fontFamily: "Outfit",
          padding: "5px 8px 5px 8px",
          height: "30px",
          border: "1px solid #e2e8f0",
          borderRadius: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LocationCityOutlinedIcon sx={{ color: "#1976d2", fontSize: "14px" }} />
        <span
          style={{
            fontWeight: "800",
            color: "#314158",
            fontSize: "14px",
            lineHeight: 1,
            marginLeft: "8px",
          }}
        >
          {`${loanDetails.instituteName} | `}
          <span style={{ color: "#62748e" }}>{loanDetails.courseName}</span>
        </span>
      </div>
      )}
      {loanDetails?.workType && (
      <div
        style={{
          backgroundColor: "#F9FAFB",
          color: "#62748e",
          fontFamily: "Outfit",
          padding: "5px 8px 5px 8px",
          height: "30px",
          border: "1px solid #e2e8f0",
          borderRadius: "20px",
          lineHeight: 1,
          width: "fit-content",
        }}
      >
        <WorkOutlineOutlinedIcon sx={{ color: "#1976d2", fontSize: "14px" }} />
        <span
          style={{
            fontWeight: "800",
            color: "#314158",
            fontSize: "14px",
            lineHeight: 1,
            marginLeft: "8px",
          }}
        >
          {`${loanDetails.workType} | `}
          <span style={{ color: "#62748e" }}>
            {loanDetails.businessName ? loanDetails.businessName : "-----"}
          </span>
        </span>
      </div>
      )}
      {loanDetails?.studentName && (
        <div
          style={{
            backgroundColor: "#F9FAFB",
            color: "#62748e",
            fontFamily: "Outfit",
            padding: "5px 8px 5px 8px",
            height: "30px",
            border: "1px solid #e2e8f0",
            borderRadius: "20px",
            lineHeight: 1,
            width: "fit-content",
          }}
        >
          <AssignmentIndOutlinedIcon
            sx={{ color: "#1976d2", fontSize: "14px" }}
          />
          <span
            style={{
              fontWeight: "800",
              color: "#314158",
              fontSize: "14px",
              lineHeight: 1,
              marginLeft: "8px",
            }}
          >
            {`Student | `}
            <span style={{ color: "#62748e" }}>
              {loanDetails.studentName ? loanDetails.studentName : "----"}
            </span>
          </span>
        </div>
      )}
    </div>
  );
}
